var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-success text-nowrap",attrs:{"href":'/projects/accept/'+_vm.project_id}},[_vm._v("Accept Quote")])
}
var staticRenderFns = []

export { render, staticRenderFns }